import React from "react";

const Claimed = props => (
  <svg width={16} height={16} {...props}>
    <title>Shape</title>
    <path
      d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM7 11.4L3.6 8 5 6.6l2 2 4-4L12.4 6 7 11.4z"
      fill="#FFF"
      fillRule="nonzero"
    />
  </svg>
);

export default Claimed;
